import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { LoadingSpinner } from "Projects/CC_cubi_clan_project/GlobalComponents/LoadingSpinner/LoadingSpinner";
import { NavMenu } from "Projects/CC_cubi_clan_project/GlobalComponents/NavMenu/NavMenu";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { handleNavLinks } from "Projects/CC_cubi_clan_project/Utils/Utils";


import {
  MDBContainer
} from "mdb-react-ui-kit";
import Asistencias from "Projects/HAPK_hapkiapp_project/Components/Asistencias/Asistencias";
import Gestionar from "Projects/HAPK_hapkiapp_project/Components/Gestionar/Gestionar";
import Home from "Projects/HAPK_hapkiapp_project/Components/Home/Home";


export default function HomeView() {
  const [isLoggedIn, setisLoggedIn] = useState(false);
  const [appPermissions, setAppPermissions] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [navActive, setNavActive] = useState("Home");
  const [navMenu, setNavMenu] = useState();
  const navigate = useNavigate();
    const location = useLocation();
  

  const navMenuDefault = [
    {
      devName: "ManagerMode",
      label: "Gestionar Web",
      url: "/home/manageWeb",
      disabled: false,
      permissionRequired: ["MANAGER_MODE"],
    },
    {
      devName: "AssistManager",
      label: "Asistencias",
      url: "/home/asistencias",
      disabled: false,
      permissionRequired: ["ASSIST_MANAGER"],
    },
    {
      devName: "HOME",
      label: "Home",
      url: "/home",
      active: true,
      visible: true,
      disabled: false,
      permissionRequired: [],
    },
  ];

  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function initData(event) {
    let app = await getApps(event);
    let appPermissions = await getAppPermisions(app);
    setAppPermissions(appPermissions);
    setNavMenuVisibles(appPermissions);
  }

  function setNavMenuVisibles(appPermissions) {
    for (let nav of navMenuDefault) {
      nav.visible = true;
      for (let per of nav.permissionRequired) {
        if (!appPermissions?.find((element) => element.nombre === per)) {
          nav.visible = false;
          break;
        }
      }
    }
    setNavMenu(navMenuDefault);
  }

  async function getApps() {
    setLoading(true);

    let app;

    await doFetch("SSO", "getAllAplicaciones", null)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        app = data.DATA.find((element) => element.nombre === "HAPK");
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        setLoading(false);
      });

    return app;
  }

  async function getAppPermisions(selectedApp) {
    let permisosList = [];
    if (selectedApp && selectedApp.IDAplicacion) {
      let idApp = selectedApp.IDAplicacion;
      setLoading(true);

      let requestOptions = {
        method: "GET",
      };

      let method = "getMyAppPermisions?IDAplicacion=" + idApp;

      await doFetch("SSO", method, requestOptions)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          permisosList = data.DATA;
        })
        .catch((error) => {
          console.error(
            "Error al obtener datos:",
            JSON.stringify(error, null, 2)
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
    return permisosList;
  }

  const onHandleNavLinks = (event, url) => {
    handleNavLinks(event, url, navigate, setNavActive);
  };

  return (
    <div>
      <LoadingSpinner isLoading={isLoading} />
      {navMenu ? (
        <NavMenu
          title="HAPKIAPP"
          appCode="HAPK"
          navMenu={navMenu}
          isLoggedIn={true}
          onHandleNavLinks={onHandleNavLinks}
          onLoading={setLoading}
          onNavigate={navigate}
        ></NavMenu>
      ) : (
        <></>
      )}
      <MDBContainer>
        {location.pathname === "/home" ? (
          <Home
          onNavigate={(event) => navigate(event)}
          onLoading={setLoading}
          onHandleNavLinks={(event, url) => handleNavLinks(event, url, navigate, setNavActive)}
        />
        ) : (
          <></>
        )}
        {location.pathname === "/home/asistencias" ? (
          <Asistencias
            onNavigate={(event) => navigate(event)}
            onLoading={setLoading}
            onHandleNavLinks={(event, url) => handleNavLinks(event, url, navigate, setNavActive)}
          />
        ) : (
          <></>
        )}
        {location.pathname === "/home/manageWeb" ? (
          <Gestionar
            onNavigate={(event) => navigate(event)}
            onLoading={setLoading}
            onHandleNavLinks={(event, url) => handleNavLinks(event, url, navigate, setNavActive)}
          />
        ) : (
          <></>
        )}
      </MDBContainer>
    </div>
  );
}
